import { Controller } from '@hotwired/stimulus'

/*
 * Litigant Messaging — CopyCheckboxController
 * Scaffold registered in Task 4. Implementation in Task 14.
 */
export default class extends Controller {
    connect() {}
}
